import React from "react";

import isIntuit from "Intuit/isIntuit";
import isSquare from "Square/isSquare";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Card, CardSection, CardHeader } from "Common/Card";
import Icon from "Common/Icon";
import { usePartnerContext } from "Common/PartnerContext";
import { launchSalesforceChat } from "Common/salesforceChatApi";

export const NoPlanSuiteCard = () => (
  <Card p={0}>
    <CardHeader>Sorry! We don't currently offer any plans in your area.</CardHeader>
    <CardSection>
      {!(isIntuit() || isSquare()) ? (
        <BodyText className="content">
          We are continually expanding our coverage options so be sure to check back again soon. Please ensure you entered the correct zip code. You can change
          it <a href="change-zip-code">here.</a>
        </BodyText>
      ) : (
        <BodyText className="content">We are continually expanding our coverage options so be sure to check back again soon.</BodyText>
      )}

      <br />
      <BodyText className="content">
        Need Help? Our experienced agents can help you with any questions you might have about specific plans, choosing the right policy for your business, and
        much more.
      </BodyText>
      <br />
      <BodyText size="large" componentClass="span">
        <Button
          color="link"
          size="large"
          p={0}
          onClick={() => {
            launchSalesforceChat();
            AnalyticsTracking.trackEvent("get_expert_help_clicked", {
              location: "no_plan_card",
              feature: "contact_us_footer_card",
            });
          }}
        >
          <Icon icon="comments" pr={2} flavor="solid" />
          Chat with an Agent
        </Button>
      </BodyText>
      <BodyText size="large" componentClass="span" pl={5}>
        <Icon icon="phone" pr={2} flavor="solid" />
        Call us at {usePartnerContext().supportPhone}
      </BodyText>
    </CardSection>
  </Card>
);

export default NoPlanSuiteCard;
